import React from 'react';
import { Link } from 'react-router-dom';
import kerekparImg from '../img/kerekparszallitas.png';
import '../App.css';

const QUOTE_PATH = '/ajanlat/kerekpar-szallitas';

const QUOTE_ITEMS = [
  'felvételi és lerakási cím (város, irányítószám, ország)',
  'kerékpár / motor típusa, darabszáma, hozzávetőleges mérete és súlya',
  'csomagolás/rögzítés állapota (van-e doboz, fólia, rögzítőpont)',
  'felvétel helye: magánszemély vagy üzlet (időpont egyeztetés)',
  'különleges igény (értékes, veterán, sérülékeny alkatrészek)',
];

function IconBike() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="18" cy="44" r="8" stroke="currentColor" strokeWidth="2" />
      <circle cx="46" cy="44" r="8" stroke="currentColor" strokeWidth="2" />
      <path
        d="M18 44l10-20h10l8 12M28 24l6 20M28 24h-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M42 20h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function IconPickup() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M12 30l20-14 20 14v22H12V30z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M22 52V36h20v16" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M6 50c6-8 14-12 26-12s20 4 26 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function IconMotor() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="18" cy="46" r="7.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="48" cy="46" r="7.5" stroke="currentColor" strokeWidth="2" />
      <path
        d="M24 46l6-16h10l6 10h-8l-4-6M30 30h-8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M40 22h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M34 46h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default function KerekparSzallitasPage() {
  return (
    <main className="svc-page">
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <nav className="svc-breadcrumb-trail" aria-label="Útvonal">
            <Link className="svc-breadcrumb-seg" to="/" state={{ scrollTo: 'szolgaltatas' }}>
              Szolgáltatások
            </Link>
            <span className="svc-breadcrumb-sep" aria-hidden="true">
              /
            </span>
            <span className="svc-breadcrumb-current" aria-current="page">
              Motorkerékpár / kerékpár szállítás
            </span>
          </nav>

          <div className="svc-hero-grid">
            <div className="svc-hero-text">
              <h1>Motorkerékpár és kerékpár szállítás</h1>
              <p>
                Tévhit, hogy biciklit szállítani olyan, mint egy egyszerű csomagszállítás. Ez több
                odafigyelést igényel, mint egy egyszerű csomag, mert nem behatárolhatóak a dimenziói.
              </p>
              <Link className="primary-btn svc-hero-cta" to={QUOTE_PATH}>
                Ajánlatot kérek
              </Link>
            </div>

            <div className="svc-hero-media">
              <img src={kerekparImg} alt="Kerékpár és motorkerékpár szállítás" />
            </div>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--cream svc-icon-rows-wrap" aria-label="Hasznos információk">
        <div className="svc-band-inner svc-icon-rows-inner">
          <p className="svc-cream-intro">
            Kerékpár és motor szállításnál minden esetben előre egyeztetünk, és a szállításhoz megfelelő
            rögzítést, eszközöket használunk.
          </p>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconBike />
            </div>
            <p className="svc-icon-row-text">
              <strong>Kerékpár fajták</strong>, amit már szállítottunk: felnőtt kerékpár, gyerekkerékpár,
              fekvő kerékpár, szoba kerékpár, tandem, tricikli, elektromos kerékpár…
            </p>
          </div>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconPickup />
            </div>
            <p className="svc-icon-row-text">
              A felvétel történhet <strong>magánszemélynél vagy üzletben</strong>. Mindkét ponton előtte
              egyeztetünk.
            </p>
          </div>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconMotor />
            </div>
            <p className="svc-icon-row-text">
              <strong>Motorkerékpár szállítás</strong>: a motor nem kerékpár, ezért a szállításban is van
              különbség. Felkészülten érkezünk, megfelelő eszközöket használunk (rögzítő heveder, mobil
              rámpa stb.). Motor fajták: robogó, moped, motorkerékpár 50 cm³ – akár 1600 cm³, veterán
              motor, Quad.
            </p>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--quote" aria-labelledby="bike-quote-h">
        <div className="svc-band-inner svc-quote-layout">
          <div className="svc-quote-main">
            <h2 id="bike-quote-h">Mi alapján készül az ajánlat?</h2>
            <p className="svc-quote-lead">A pontos ajánlathoz kérjük add meg:</p>
            <ul className="svc-bullet-list svc-bullet-list--quote">
              {QUOTE_ITEMS.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
            <p className="svc-tip svc-tip--in-card">
              Ha tudsz, csatolj fotót a járműről (kerékpár/motor) – így gyorsabban és pontosabban tudunk
              ajánlatot adni.
            </p>
          </div>

          <aside className="svc-quote-aside" aria-labelledby="bike-quote-info-h">
            <h2 id="bike-quote-info-h" className="svc-quote-aside-title">
              Információk:
            </h2>
            <ul className="svc-quote-info-list">
              <li>
                Kérünk, hogy a pontos árajánlathoz <strong>minden mezőt tölts ki</strong> a valóságnak
                megfelelően!
              </li>
              <li>
                A <strong>csillaggal jelölt mezők</strong> kitöltése kötelező.
              </li>
              <li>
                Áraink <strong>nettó árak</strong>. Az Áfát nem tartalmazzák!
              </li>
              <li>
                Az árajánlat elküldését követően <strong>1–5 napon belül</strong> tudjuk a pontos
                árajánlatot kiküldeni.
              </li>
            </ul>
          </aside>
        </div>
      </section>

      <section className="svc-band svc-band--dark">
        <div className="svc-band-inner svc-closing">
          <h2>Kerékpárt vagy motort szállíttatnál?</h2>
          <p>Küldd el a fő adatokat, és készítünk egy személyre szabott ajánlatot.</p>
          <Link className="primary-btn svc-closing-btn" to={QUOTE_PATH}>
            Ajánlatot kérek
          </Link>
        </div>
      </section>

      <section className="svc-band svc-band--white svc-gyik-band">
        <div className="svc-band-inner svc-gyik-row">
          <p className="svc-gyik-text">
            Ha valami kérdésed maradt még, email vagy telefon előtt keresd a GYIK-ben.
            <br />
            Biztos rátalálsz a válaszra.
          </p>
          <Link className="svc-gyik-link" to="/gyik">
            Tovább a GYIK-hez →
          </Link>
        </div>
      </section>
    </main>
  );
}

